class Timeline {
  constructor(root) {
    this.root = root;
    this.timelineSwiper = null;
    this.infoSwiper = null;
    this.slideHandlers = [];
    this.initTimeline();
  }

  initTimeline() {
    const container = this.root.querySelector('.timeline-swiper');
    const infoContainer = this.root.querySelector('.info-swiper');

    if (!container || !infoContainer) {
      return;
    }

    const SwiperClass = window.Swiper || window.swiper;
    if (!SwiperClass) {
      return;
    }

    const infoNext = this.root.querySelector('.swiper-button-next');
    const infoPrev = this.root.querySelector('.swiper-button-prev');
    const infoPag = this.root.querySelector('.swiper-pagination');
    const swiperModules = [];

    if (SwiperClass.Navigation) {
      swiperModules.push(SwiperClass.Navigation);
    }
    if (SwiperClass.Pagination) {
      swiperModules.push(SwiperClass.Pagination);
    }
 
    this.timelineSwiper = new SwiperClass(container, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      freeMode: true
    });

    this.infoSwiper = new SwiperClass(infoContainer, {
      modules: swiperModules.length ? swiperModules : undefined,
      slidesPerView: 1,
      allowTouchMove: true,
      navigation: infoNext && infoPrev ? {
        nextEl: infoNext,
        prevEl: infoPrev,
      } : undefined,
      pagination: infoPag ? {
        el: infoPag,
        clickable: true,
      } : undefined,
    });

    this.timelineSwiper.on('slideChange', () => {
      if (this.infoSwiper.activeIndex !== this.timelineSwiper.activeIndex) {
        this.infoSwiper.slideTo(this.timelineSwiper.activeIndex);
      }
      this.updateTimelineBackground();
    });

    this.infoSwiper.on('slideChange', () => {
      if (this.timelineSwiper.activeIndex !== this.infoSwiper.activeIndex) {
        this.timelineSwiper.slideTo(this.infoSwiper.activeIndex);
      }
    });

    this.timelineSwiper.slides.forEach((slide, index) => {
      const handler = () => this.timelineSwiper?.slideTo(index);
      slide.addEventListener('click', handler);
      this.slideHandlers.push([slide, handler]);
    });

    requestAnimationFrame(() => {
      this.updateTimelineBackground();
      this.infoSwiper?.slideTo(this.timelineSwiper?.activeIndex || 0, 0);
    });
  }

  updateTimelineBackground() {
    const swiper = this.timelineSwiper;
    const current = swiper?.slides?.[swiper.activeIndex];
    if (!swiper || !current) return;

    const previous = swiper.slides[swiper.activeIndex - 1];
    const next = swiper.slides[swiper.activeIndex + 1];
    const setText = (selector, value) => {
      const element = this.root.querySelector(selector);
      if (element) element.textContent = value;
    };

    setText('.year-bg.current', current.dataset.year || '...');
    setText('.year-bg.prev', previous?.dataset.year || '...');
    setText('.year-bg.next', next?.dataset.year || '...');

    const progress = this.root.querySelector('.progress-bar');
    const containerWidth = swiper.el?.clientWidth || 0;
    if (progress && containerWidth > 0) {
      const slideCenter = current.offsetLeft + current.offsetWidth / 2;
      const progressRatio = Math.max(0, Math.min(1, slideCenter / containerWidth));
      progress.style.transform = `scaleX(${progressRatio})`;
    }
  }

  destroy() {
    this.slideHandlers.forEach(([slide, handler]) => slide.removeEventListener('click', handler));
    this.slideHandlers = [];
    this.timelineSwiper?.destroy(true, true);
    this.infoSwiper?.destroy(true, true);
    this.timelineSwiper = null;
    this.infoSwiper = null;
  }
}

export default Timeline;
